import { Component, OnInit,Output,EventEmitter,ElementRef,ViewChild } from '@angular/core';
import { GastroFormsService } from '../gastro-forms.service';
import { LoginService } from 'src/app/login.service';
import { AutotextService } from '../autotext.service';
import { fromEvent,Subject, Subscription} from 'rxjs';
import { map, tap, switchMap, takeUntil, finalize} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { PatientsService } from '../patients.service';

@Component({
    selector: 'app-release',
    templateUrl: './release.component.html',
    styleUrls: ['./release.component.scss'],
    standalone: false
})
export class ReleaseComponent implements OnInit {
  @Output() closed = new EventEmitter<string>();
  @Output() print = new EventEmitter<string>();
  @ViewChild("canvasSign", { static: true })
  canvasSign: ElementRef<HTMLCanvasElement>;
  changeCanvas$ = new Subject();
  destroy$ = new Subject();
  sub = new Subscription();
  ctx: CanvasRenderingContext2D;
  formLoaded=new Subscription

  constructor(public gfs:GastroFormsService, public ls:LoginService,public atS:AutotextService,private http:HttpClient,public patServ:PatientsService) { }

  ngOnInit(): void {
    this.formLoaded=this.gfs.formLoaded$.subscribe(()=>{
      if (this.gfs.Form && this.gfs.Form.get('nurseSign').value) {
        this.loadSign();
      }
      
      this.gfs.Form.get('EndTime').disable();
  
      if(this.gfs.Form && !this.gfs.Form.get('EndTime').value){
        this.loadEndTime()
      }
    })
  }
  close(toclose: boolean) {
    this.closed.emit(toclose ? '1': null);
  }
  printForm(){
    this.print.emit('1')
  }
  ngAfterViewInit(){
    this.sub = this.changeCanvas$
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: any) => {
        this.ctx = data.ctx;
        const mouseDownStream = fromEvent(
          this.canvasSign.nativeElement,
          "mousedown"
        );
        const mouseMoveStream = fromEvent(
          this.canvasSign.nativeElement,
          "mousemove"
        );
        const mouseUpStream = fromEvent(window, "mouseup");
        mouseDownStream
          .pipe(
            tap((event: MouseEvent) => {
              this.ctx.beginPath();
              this.ctx.strokeStyle = "black";
              this.ctx.lineWidth = 5;
              this.ctx.lineJoin = "round";
              this.ctx.moveTo(event.offsetX, event.offsetY);
            }),
            switchMap(() =>
              mouseMoveStream.pipe(
                tap((event: MouseEvent) => {
                  this.ctx.lineTo(event.offsetX, event.offsetY);
                  this.ctx.stroke();
                }),
                takeUntil(mouseUpStream),
                finalize(() => {
                  // this.ctx.closePath();
                  this.saveSign();
                })
              )
            )
          )
          .subscribe((data) => {
            // console.log(data);
          });
      });
  }

  clearSign() {
        var ctx = this.canvasSign.nativeElement.getContext("2d");
        ctx.clearRect(
          0,
          0,
          this.canvasSign.nativeElement.width,
          this.canvasSign.nativeElement.height
        );
        this.gfs.Form.get('nurseSign').setValue('');
      
    
    }

  setCanvas() {
    this.ctx = this.canvasSign.nativeElement.getContext("2d");
    this.changeCanvas$.next({ canvas: this.canvasSign, ctx: this.ctx });
  }

  saveSign() {
    let canvasUrl = this.canvasSign.nativeElement.toDataURL("image/png");
        this.gfs.Form.get("nurseSign").setValue(canvasUrl);
       
    }

    loadSign(){
      var ctx = this.canvasSign.nativeElement.getContext("2d");
        const imgNurseSign = document.createElement("img");
        imgNurseSign.onload = function () {
          ctx.drawImage(imgNurseSign, 0, 0); // Or at whatever offset you like
        };
        imgNurseSign.src = this.gfs.Form.get("nurseSign").value;
    }

    ngOnDestroy(): void {
     if(this.formLoaded)
     this.formLoaded.unsubscribe()
    }
  
    loadEndTime(){
      let p = this.patServ.getPat();
      if(!p.AWLID) return
      this.http.get(`/api/gastro/getReleaseTime/${p.AWLID}`).subscribe((data)=>{
      if (data['EndTime']){
        this.gfs.Form.get('EndTime').setValue(data['EndTime'])
      }
       return
      })
    }
  


}
